/*
  CustomerRequest.js - CustomerRequest Networking File

  Contains networking functionality for Admin Customer Components

  Author: Kyle Combeer (2019)
  Company: Virtual Ark
*/

// OUR MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const CustomerRequest = () => {
  /*
    Send a request to create a new Customer given a Customer object
    from a form
  */
  const createNewCustomer = async (newCustomer, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/customer/`;
      const body = JSON.stringify(newCustomer);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        body: body,
        headers: headers,
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Gets a list of Sales Agents for the given Provider Id
  */
  const getSalesAgents = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/contact/agent?select=single`;
      const options = {
        method: 'GET',
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Fetches extra data for creating a new Customer.
    - Tariff Plans options
    - Class - Type options
  */
  const getCustomerExtras = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/customer/extras`;
      const options = {
        method: 'GET',
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      return errorHandler(e);
    }
  };

  /*
    Fetches campaign data for the customer.
  */
  const getCustomerCampaignData = async (customerId, errorHandler) => {
    try {
      const url =
        `${config.baseServerURL}/admin/customer/campaigns/` + customerId;
      const options = {
        method: 'GET',
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      return errorHandler(e);
    }
  };

  /*
    Fetches pool number data for the customer.
  */
  const getAllNumbers = async (customerId, errorHandler) => {
    try {
      const url =
        `${config.baseServerURL}/admin/customer/numbers/` + customerId;
      const options = {
        method: 'GET',
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      return errorHandler(e);
    }
  };

  /*
    Fetches pool number data for the customer.
  */
  const getPoolNumbers = async (customerId, errorHandler) => {
    try {
      const url =
        `${config.baseServerURL}/admin/customer/numbers/pool/` + customerId;
      const options = {
        method: 'GET',
      };

      // Make Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      return errorHandler(e);
    }
  };

  /*
    Calls TWILIO api to request 20 possible numbers for a given Country Code and Prefix
  */

  const getTwilioProvisional = async (data, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/users/number/search?countryCode=${data.country}`;

      if (data.prefix) url += `&areaCode=${data.prefix}`;
      if (data.selectedGateway) url += `&gateway=${data.selectedGateway}`;
      if (data.numberContains) url += `&numberContains=${data.numberContains}`;

      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'GET',
        headers: headers,
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const provisionNumbers = async (data, errorHandler) => {
    try {
      console.log('provisionTwilioNumbers called');
      let url = `${config.baseServerURL}/admin/customer/numbers/provision`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      console.log('options:', options);

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      console.log('responseJSON:', responseJSON);
      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const releaseTwilioNumbers = async (data, errorHandler) => {
    try {
      console.log('releaseTwilioNumbers called');
      let url = `${config.baseServerURL}/admin/customer/numbers/release`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      console.log('JSON.stringify(data):', JSON.stringify(data));
      console.log('options:', options);

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const changeTwilioNumbers = async (data, customerId, errorHandler) => {
    try {
      console.log('changeTwilioNumbers called');
      let url = `${config.baseServerURL}/admin/customer/numbers/change`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ numbers: data, customerId: customerId }),
      };

      console.log('JSON.stringify(data):', JSON.stringify(data));
      console.log('options:', options);

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const requestBrandAndCampaign = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/customer/request-campaign`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      // Request
      const response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  const upgradeTrialCustomer = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/customer/upgrade`;
      const headers = {
        'Content-Type': 'application/json',
      };
      const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
      };

      // Request
      const response = await RequestRabbit.request(url, options, errorHandler);
      console.log('response', response);
      return response;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Returns all Providers in the system
  */
  const getAllProviders = async (errorHandler) => {
    try {
      // Params
      const url = `${config.baseServerURL}/admin/provider/`;
      const options = {
        method: 'GET',
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e.message);
    }
  };

  /*
    Used to retrieve Tariff Plans solely for Provider use, for the given provider_id
  */
  const getTariffPlans = async (providerId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/tariff/plan?provider_id=${providerId}`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();
      if (response.status > 399 && response.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      // TODO: why does this and the other request above throw????
      throw e;
    }
  };

  const getCompliance = async (customerId, errorHandler) => {
    try {
      return await RequestRabbit.get(
        `/admin/customer/compliance/${customerId}`,
        {},
        errorHandler
      );
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  };

  const updateCompliance = async (customerId, data, errorHandler) => {
    try {
      return await RequestRabbit.put(
        `/admin/customer/compliance/${customerId}`,
        data,
        errorHandler
      );
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  };

  return {
    changeTwilioNumbers,
    createNewCustomer,
    getAllNumbers,
    getAllProviders,
    getCustomerCampaignData,
    getCustomerExtras,
    getPoolNumbers,
    getSalesAgents,
    getTariffPlans,
    getTwilioProvisional,
    provisionNumbers,
    releaseTwilioNumbers,
    requestBrandAndCampaign,
    upgradeTrialCustomer,
    getCompliance,
    updateCompliance,
  };
};

export default CustomerRequest;
